import { hapticFeedback } from '@telegram-apps/sdk';
import { useInviteCodes } from '../../hooks';
import './Admin.css';

export function InviteCodeSection() {
  const { codes, isLoading, generateCode, isGenerating } = useInviteCodes();

  const handleGenerate = async () => {
    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred('medium');
    }
    try {
      await generateCode();
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred('success');
      }
    } catch {
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred('error');
      }
    }
  };

  const handleCopyCode = (code: string) => {
    navigator.clipboard.writeText(code);
    if (hapticFeedback.notificationOccurred.isAvailable()) {
      hapticFeedback.notificationOccurred('success');
    }
  };

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <div className="admin-section-header-left">
          <span className="admin-section-icon">🎟️</span>
          <span className="admin-section-title">Инвайт-коды</span>
        </div>
        {codes && codes.length > 0 && (
          <span className="admin-section-count">{codes.length}</span>
        )}
      </div>

      <div className="admin-section-body">
        <button
          type="button"
          className="admin-btn admin-btn--primary"
          onClick={handleGenerate}
          disabled={isGenerating}
        >
          {isGenerating ? (
            <>
              <span className="admin-btn-spinner" />
              Генерация...
            </>
          ) : (
            <>✨ Сгенерировать код</>
          )}
        </button>

        {isLoading ? (
          <div className="admin-section-loading">
            <div className="admin-section-spinner" />
          </div>
        ) : codes && codes.length > 0 ? (
          <div className="admin-code-list">
            {codes.map((code, index) => (
              <div
                key={code.code}
                className="admin-code-item admin-animate-item"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <div className="admin-code-info">
                  <div className="admin-code-value">{code.code}</div>
                  <div className="admin-code-expires">До {formatDate(code.expiresAt)}</div>
                </div>
                <button
                  type="button"
                  className="admin-code-copy"
                  onClick={() => handleCopyCode(code.code)}
                >
                  📋
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="admin-empty-state">
            <div className="admin-empty-state-icon">🎫</div>
            <div>Нет активных кодов</div>
          </div>
        )}
      </div>
    </div>
  );
}
